import http from "../../http-common";
/* eslint-disable */
class BrosurService {
  brosurList(page, itemPerPage, keyword) {
    return http.get(
      "/brosur/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("judul", data.judul);
    bodyFormData.append("file_name", data.file_name);

    if (data.file_url != null) bodyFormData.append("photo", data.file_url);

    return http.post("/brosur", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("judul", data.judul);
    bodyFormData.append("file_name", data.file_name);

    if (data.file_url != null) bodyFormData.append("photo", data.file_url);

    return http.put(`/brosur/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/brosur/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new BrosurService();
